module.exports = __webpack_public_path__ + "static/scale-model-of-independence-missouri-fdc6f6bac92e8aad3b02d674e5203aad.png";